import { getActionText } from 'copilot-toolkit/actions/getActionText';
import setIn from 'transmute/setIn';
import { createAuthTokenRpc } from '../../../__generated__/chirp/com/hubspot/copilot/rpc/CopilotChatService';
import { createRpc } from '../../../__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotThreadsService';
import { rpcClient } from '../../http/rpcClient';
import { streamingClient } from '../../http/streamingClient';
const parseMessageAction = messageAction => {
  const parsedText = getActionText(messageAction);
  const parsedActionData = Object.keys(messageAction.data).reduce((acc, key) => {
    const keyPath = key.split('.');
    return setIn(keyPath, messageAction.data[key], acc);
  }, {});
  const cleanMessageAction = Object.fromEntries(Object.entries(messageAction).filter(([key]) => key !== 'raw_action'));
  const actionText = messageAction.text || parsedText;
  const result = Object.assign({}, cleanMessageAction, {
    data: parsedActionData
  }, actionText ? {
    text: actionText
  } : {});
  return result;
};
export const sendStreamingChatMessage = ({
  appContext,
  freeContext,
  locale,
  onError,
  onProgress,
  onClose,
  message,
  source,
  sourceHostApp,
  sourceHostAppPathname,
  threadId,
  template,
  extraIntentProperties,
  isSavedPrompt,
  isCollaborateMode
}) => streamingClient.post('chatspot-streaming/v1/api/chat', {
  data: {
    locale,
    message,
    plugins: [],
    source,
    sourceHostApp,
    sourceHostAppPathname,
    threadId,
    templateId: template ? template.id : undefined,
    isSavedPrompt,
    isCollaborateMode,
    additionalContext: {
      appContext: Object.assign({}, appContext, freeContext ? {
        pageContext: JSON.stringify(freeContext)
      } : {})
    },
    extraIntentProperties
  },
  onProgress,
  onClose,
  onError
});
export const sendStreamingMessageAction = ({
  locale,
  onError,
  onProgress,
  onClose,
  messageAction,
  source,
  sourceHostApp,
  sourceHostAppPathname,
  threadId,
  template,
  freeContext,
  isCollaborateMode
}) => {
  return streamingClient.post('chatspot-streaming/v1/api/action', {
    data: {
      action: parseMessageAction(messageAction),
      locale,
      source,
      sourceHostApp,
      sourceHostAppPathname,
      threadId,
      templateId: template ? template.id : undefined,
      isCollaborateMode,
      additionalContext: {
        pageContext: {
          freeContext
        }
      }
    },
    onProgress,
    onClose,
    onError
  });
};

/**
 * Copilot V2 related API calls
 * Powered by Ably API to implement realtime chat via Websockets
 * */
export const fetchAblyAuthToken = ({
  clientId,
  threadId
}) => {
  return rpcClient.call(createAuthTokenRpc, {
    request: {
      clientId,
      threadId
    }
  });
};
export const initializeAblyChatForCopilotV2 = ({
  customCopilotId
}) => {
  return rpcClient.call(createRpc, {
    request: {
      customCopilotId
    }
  });
};